import {CardType, getCardTypeIcon} from 'helpers/getCardTypeIcon';
import styles from './CreditCardType.module.scss';

export const CreditCardType = ({type}: {type: CardType}) => {
  if (!type) return null;
  if (!getCardTypeIcon(type)) return null;
  return (
    <img
      className={styles.creditCardTypeIcon}
      src={getCardTypeIcon(type)}
      alt="card type"
    />
  );
};
